import React, { Component } from 'react'
import './style.css'
import Banner from '../../assets/image/banner-homepage-3.jpg'
import Banner2 from '../../assets/image/banner-homepage2.jpg'
import {Button} from '@material-ui/core'
// import Slider from 'infinite-react-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import {
    ButtonBack, ButtonFirst, ButtonLast, ButtonNext,
    CarouselProvider, DotGroup, ImageWithZoom, Slide, Slider,
  } from 'pure-react-carousel'
  import {getBanner,getCaption} from '../../redux/action/home'
import {connect} from 'react-redux'
class tribe_banner extends Component {
    componentDidMount(){
        this.props.getBanner()
        this.props.getCaption()
       }
    render() {
        const {image,home}=this.props
        console.log('home.banner', home.banner)
        return (
            <div>
                <section className='landing-tribe hide-mobile'>
                    <div className='banner-tribe'>
                        <h1>{this.props.home.welcome}</h1>
                        <br/>
                        <p>{this.props.home.welcomeNote}</p>
                        <br/>
                        <Button variant="contained" style={{textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" className='btn-shadow' style={{textTransform:'none',fontWeight:'bold',border:5,border:5,backgroundColor:'white'}} color="primary" onClick={()=>window.location.assign('/organitationassessment')}>Organization Assessment</Button>
                        {/* <Button variant="contained" style={{textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button> */}
                    </div>
                    <div className='banner-img' style={{textAlign:'center'}}>
                    <div className="dot"></div>
                    {/* <Carousel showArrows={false} autoPlay infiniteLoop={true} showIndicators={false} showThumbs={false} showStatus={false} >
                        {image.map((data,i)=>(
                            <div >
                                <div className="image">
                                    <img src={data.image} className='banner-slider'/>
                                </div>
                                <div className='sadow'></div>
                            </div>
                        ))} 
                    </Carousel> */}
                    <CarouselProvider
                        naturalSlideWidth={1}
                        naturalSlideHeight={1}
                        totalSlides={home.banner.length+1}
                        isPlaying={true}
                        interval={67000}
                        playDirection='forward'
                    >

                        <Slider>
                        
                           {home.banner.map((data,i)=>(
                                <Slide index={i} key={i}>
                                    <div className="image" style={{cursor:'pointer'}} onClick={()=>data.link!==null&&window.location.assign(data.link)}>
                                        <img src={data.url} className='banner-slider'/>
                                    </div>
                                    <div className='sadow'></div>
                                    <div style={{position:'absolute',top:340}}>
                                    <DotGroup className='dot-slider'/>
                                    </div>
    
                                </Slide>
                            ))}
                            <Slide >
                                <div className="video" style={{cursor:'pointer'}} onClick={()=>null}>
                                <video className="video-slider" loop="true" autoplay="autoplay" muted id="myVideo" >
                                        <source src="https://www.onegml.com/assets/videos/v5m20210129.mp4" type="video/mp4"/>
                                </video>
                                </div>
                                <div className='sadow'></div>
                                <DotGroup className='dot-slider'/>

                            </Slide>

                        </Slider>
                    </CarouselProvider>
                    </div>
                </section>
                <div className='image-mobile show-mobile'>
                    <div className='image-banner-mobile'>
                    <div  className='image-banner-mobile'>
                                <img src={Banner} />
                            </div>
                    {/* <Carousel showArrows={false} autoPlay infiniteLoop={true} showIndicators={false} showThumbs={false} showStatus={false} >
                        {image.map((data,i)=>(
                            <div  className='image-banner-mobile'>
                                <img src={data.image} />
                            </div>
                        ))} 
                    </Carousel> */}
                        {/* {image.length>1?
                    <CarouselProvider
                        naturalSlideWidth={2}
                        naturalSlideHeight={2}
                        totalSlides={image.length}
                        isPlaying={true}
                        interval={5000}
                        playDirection='forward'
                    >
                        <Slider>
                        {image.map((data,i)=>(
                                <Slide index={i} key={i}>
                                    <div  className='image-banner-mobile'>
                                        <img src={data.image} />
                                            <div className='dot-mobile'>
                                            <DotGroup className='dot-slider'/>
                                        </div>
                                    </div>
                                </Slide>
                            ))}
                            
                        </Slider>
                        
                    </CarouselProvider>
                    :
                    <div  className='image-banner2-mobile'>
                        <img src={image[0].image} />
                            <div className='dot-mobile'>
                        </div>
                    </div>
                    } */}
                        <div className='image-caption-mobile'>
                            <h1>{this.props.title}</h1>
                            <br/>
                            <p>{this.props.subtitle}</p>
                            <br/>
                            <div style={{textAlign:'center'}}>
                            <Button variant="contained" style={{borderRadius:10,width:220,textTransform:'none',fontWeight:'bold',border:5}} color="primary" onClick={()=>window.location.assign('/schedule')}>Schedule a meeting</Button>
                            
                            <Button variant="outlined" style={{marginTop:15,borderRadius:10,width:220,textTransform:'none',fontWeight:'bold',border:5,backgroundColor:'white',boxShadow:'0 3px 6px 0 rgba(0, 173, 255, 0.35)'}} className='btn-shadow' color="primary" onClick={()=>window.location.assign('/organitationassessment')}>Organization Assessment</Button>

                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps=(state)=>({
    general:state.general,
    home:state.home
})
const mapDispatchToProps={
    getBanner,
    getCaption
}
export default connect(mapStateToProps,mapDispatchToProps)(tribe_banner)

